import React, { useState, useEffect } from "react";
import Widgets from "../../HomeCards/Card";
import CurrencyFormat from "react-currency-format";

const TransactionProjectTypeTotal = (props) => {
  return (
    <Widgets
      icon="stats"
      currency={"Tümü"}
      title="Toplam Depo Sayısı"
      totalBalance={
        <CurrencyFormat
          value={props?.data}
          displayType={"text"}
          decimalSeparator={","}
          thousandSeparator={"."}
          prefix={""}
        />
      }
    />
  );
};

export default TransactionProjectTypeTotal;
